import { createContext, useContext, ReactNode } from 'react';

import { Run } from '@/api/types/backend-dto-types';
interface SettingsContextType {
  caseId: string;
  caseName: string;
  createdDate: Date | undefined;
  createdBy: string;
  isLoadingCaseIssues: boolean;
  originalIssues: string;
  caseIssues: string;
  setCaseIssues: (value: string) => void;
  originalParties: string;
  caseParties: string;
  setCaseParties: (value: string) => void;
  originalContext: string;
  caseContext: string;
  setCaseContext: (value: string) => void;
  originalTimePeriod: string;
  caseTimePeriod: string;
  setCaseTimePeriod: (value: string) => void;
  detailsChanged: boolean;
  setDetailsChanged: (value: boolean) => void;
  confirmationModalOpen: boolean;
  setConfirmationModalOpen: (value: boolean) => void;
  totalUnprocessedDocs: number;
  runs: Run[];
  setTotalUnprocessedDocs: (value: number) => void;
  handleIssuesChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handlePartiesChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleContextChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleTimePeriodChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isReprocessing: boolean;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const useSettingsContext = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettingsContext must be used within a SettingsProvider');
  }
  return context;
};

interface SettingsProviderProps {
  children: ReactNode;
  value: SettingsContextType;
}

export const SettingsProvider = ({ children, value }: SettingsProviderProps) => {
  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};
